import {AnyAction} from 'redux'
import {CHANGE_EVENT} from '../actions/event'

export const tickets = (state: wix.events.ticketing.TicketDefinition[] = [], action: AnyAction) => {
  switch (action.type) {
    case CHANGE_EVENT:
      return action.payload.tickets
    default:
      return state
  }
}
